var GenIcon = require('../lib').GenIcon

module.exports = function (props) {
   return GenIcon({"tag":"svg","attr":{"version":"1.1","id":"mdi-format-vertical-align-bottom","viewBox":"0 0 24 24","fill":"currentColor"},"child":[{"tag":"path","attr":{"d":"M16,13H13V3H11V13H8L12,17L16,13M4,19V21H20V19H4Z"}}]})(props);
};
